// label 을 주면 이름만 바꿔 단다. 문제뱅크 줄이 "문제뱅크" 대신 종류(문법·단어...)를
// 달 때 쓴다. 색은 type 것을 그대로 쓴다.
// 파닉스북(리더스북 중 이름이 'ECHO Phonics · …' / 'Ginedu Phonics · …')은 단색 대신 분홍→보라 그라데이션
// 'Phonics' 로 단다(2026-10-20 대표). 그래서 title 을 함께 받는다.
export const isPhonicsBookTitle = (title) => /(ECHO|Ginedu) Phonics/.test(String(title || ""));

const PHONICS_BADGE_STYLE = {
  background: "linear-gradient(120deg, #F0568C 0%, #B24BD8 55%, #7B3FE4 100%)",
  color: "#FFFFFF",
  boxShadow: "0 2px 6px -2px rgba(178, 75, 216, 0.55)",
};

// ECHO 발음기호(이름 'ECHO 발음기호 N', api assignment/ipa_course.py)는 남색 그라데이션 '발음기호'. 학생 typeInfo.bookBadgeOf 와 같다
const IPA_COURSE_BADGE_STYLE = {
  background: "linear-gradient(120deg, #4C7BF3 0%, #3A5BD9 55%, #2B3FA8 100%)",
  color: "#FFFFFF",
  boxShadow: "0 2px 6px -2px rgba(58, 91, 217, 0.55)",
};
const isIpaCourseTitle = (title) => /^ECHO 발음기호/.test(String(title || ""));

const WorksheetTypeBox = ({ type, label, title }) => {
  const typeInfo = {
    analysis: {
      name: "지문분석 워크북",
      backgroundColor: "#E8F7EE",
      color: "#1DB05B",
    },
    comprehensive: {
      name: "내용이해 워크북",
      backgroundColor: "#FDF3E3", // [색 스왑] 학생 사이트와 통일 — 내용이해=오렌지
      color: "#E8920A",
    },
    paragraph: {
      name: "모의고사 유형",
      backgroundColor: "#FCEDE9",
      color: "#C2452D",
    },
    vocabulary: {
      name: "단어테스트",
      backgroundColor: "#E9EFF7",
      color: "#3E6398",
    },
    sentence: {
      name: "문장테스트",
      backgroundColor: "#FBF4D9",
      color: "#8A6D00",
    },
    grammar: {
      name: "어법",
      backgroundColor: "#EFEBFC", // [색 스왑] 학생 사이트와 통일 — 어법=보라
      color: "#6B4EE6",
    },
    readers_book: {
      name: "리더스북",
      backgroundColor: "#FCEBF1",
      color: "#D14D72",
    },
    grammar_bank: {
      name: "문법",
      backgroundColor: "#EFEBFC",
      color: "#6B4EE6",
    },
    bank: {
      name: "문제뱅크",
      backgroundColor: "#EFFBF8",
      color: "#00A396",
    },
    // 지인에듀 수학 학습지(2026-10-06). 학생 화면과 같은 색: 연산은 청록, 나머지는 보라
    math_type_worksheet: { name: "수학 유형", backgroundColor: "#EFEDFC", color: "#6A5AE0" },
    math_variant: { name: "수학 변형", backgroundColor: "#EFEDFC", color: "#6A5AE0" },
    math_concept: { name: "수학 개념", backgroundColor: "#EFEDFC", color: "#6A5AE0" },
    math_drill: { name: "수학 연산", backgroundColor: "#E6F7F4", color: "#00A396" },
    math_wrong_note: { name: "수학 오답", backgroundColor: "#FFE8EE", color: "#D63C5E" },
    // 수학 월말 레벨테스트(2026-10-21). 수학 사이트가 달마다 학년별로 올리고, 선생님이 골라서 낸다
    math_level_test: { name: "레벨테스트", backgroundColor: "#FFF4DE", color: "#B26A00" },
    paper_assignment: {
      name: "지필과제",
      backgroundColor: "#F4F8F7",
      color: "#3A434E",
    },
  };

  if (!typeInfo[type]) return null;
  const isIpaCourse = type === "readers_book" && isIpaCourseTitle(title);
  const isPhonics = type === "readers_book" && !isIpaCourse && isPhonicsBookTitle(title);

  return (
    <div
      style={{
        backgroundColor: typeInfo[type].backgroundColor,
        color: typeInfo[type].color,
        ...(isPhonics ? PHONICS_BADGE_STYLE : {}),
        ...(isIpaCourse ? IPA_COURSE_BADGE_STYLE : {}),
        borderRadius: "999px",
        padding: "3px 11px",
        fontSize: "0.73rem",
        fontWeight: 700,
        display: "inline-block",
        textAlign: "center",
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      {label || (isPhonics ? "Phonics" : isIpaCourse ? "발음기호" : typeInfo[type].name)}
    </div>
  );
};

export default WorksheetTypeBox;
